import Vue from 'vue'
import Vuex from 'vuex'
import Bus from '@utils/bus'
import {http, } from '@utils'
import {ruleApi} from '@utils/api'
import queryString from 'query-string';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    searchword: '', // 关键字搜索
    searchList:{},  // 关键字搜索结果
    sidercode: '',  // 侧边栏搜索
    searchTitle: {},// 侧边栏搜索结果
    menus:[],
    csid: '',         // 目录id
  },
  mutations: {
    setSearchword(state, searchword) {
      state.searchword = searchword
    },
    setSearchList(state, searchList){
      state.searchList = searchList;
    },
    setSidercode(state, sidercode) {
      state.sidercode = sidercode
    },
    setSearchTitle(state, searchTitle){
      state.searchTitle = searchTitle;
    },
    setMenus(state, menus){
      state.menus = menus
    },
    setId(state, id) {
      state.csid = id
    }
  },
  actions: {
    async getSearchList({commit, state},value) {
      // 关键字搜索结果
      const params = {
        keyword: value.searchword ,
        start: (value.current-1)*value.pagesize,
        limit: value.pagesize,
      }
      const api = `${ruleApi.search}?${queryString.stringify(params)}`
      const res = await http.get(`${api}`)
      if (1*res.code === 0) {
        commit('setSearchList', res)
        commit('setSearchword', value.searchword )
        commit('setSearchTitle', {})
        commit('setSidercode', '')
      }
      // console.log('关键字搜索结果', params, state.searchList)
      return res.data;
    },
    async getSearchTitle({commit, state},value) {
      // 侧边栏搜索结果
      const params = {
        categoryId: value.sidercode ,
        pageNum: value.current,
        pageSize: value.pagesize,
      }
      const api = `${ruleApi.getListByCategoryId}?${queryString.stringify(params)}`
      const res = await http.get(`${api}`)
      if (1*res.code === 1) {
        commit('setSearchList', {} )
        commit('setSearchword', '' )
        commit('setSearchTitle', res)
        commit('setSidercode', value.sidercode)
      }
      // console.log('侧边栏搜索结果', params, state.searchTitle)
      return res.data;
    },
    toSearchByQuery({dispatch,commit},param){
      if(param.searchword) {
        Bus.$emit('initSideBar'); 
        dispatch('getSearchList',param);
      } else {
        dispatch('getSearchTitle',param);
      }
    },
    async getMenus({commit, state}){
      const api = `${ruleApi.getCategories}?categoryId=10`
      const res = await http.get(`${api}`)
      if (1*res.code === 1 && res.data) {
        commit('setMenus',res.data)
      } else {
        commit('setMenus',[])
      }
      return res.data;
    },
    getId({commit, state}, value) {
      commit('setId', value)
      // console.log('store',state.csid)
    }
  }
})
